module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 7
// module chunks = 0